import moment from "moment";

// This code came from willy (maybe add it in globale project like @weezevent/core)
export function handleSearchQuery(spec, filters, truncate = false) {
	let query = {};
	Object.entries(filters).forEach(([key, value]) => {
		if (truncate && !spec.fields?.includes(key)) {
			// Ignore key that are not in the spec fields in case we don't need all the object
			// For example when we want to call API we don't want all the filters,
			// just those who are useful in this case
			return;
		}

		if (value instanceof Set) {
			query[key] = Array.from(value).join(",");
			return;
		}

		// case Filter date
		if (
			spec.date &&
			spec.date.includes(key) &&
			value instanceof Object &&
			!Array.isArray(value)
		) {
			Object.entries(value).forEach(([_key, _value]) => {
				if (_value) {
					query[`${key}_${_key}`] = moment(_value)
						.set({ second: 0, millisecond: 0 })
						.toISOString();
				}
			});
			return;
		}

		query[key] = value;
	});

	return query;
}

export const toArray = value => {
	if (!value) return [];
	if (value instanceof Set) return Array.from(value);
	if (Array.isArray(value)) return value;
	return [value];
};

export const getListCount = filterValue => {
	if (!filterValue) return 0;
	if (filterValue instanceof Set) return filterValue.size;
	if (Array.isArray(filterValue)) return filterValue.length;
	return 1;
};
